const allocationStatusValues = {
  false: 0,
  true: 1,
};

const allocationStatusMapper = (appliedFilter) => {
  const value = allocationStatusValues[appliedFilter.criterionArgumentValue];
  return {
    booleanFilters: [
      {
        column: 'IsAllocated',
        value,
      },
    ],
  };
};

export default allocationStatusMapper;
